
import { Placement } from '@post-office/placements-frontend/jira-issue-view-twc-spotlight-tour';
export default Placement;
